import React from "react";
import { Box, Typography, FormControlLabel, Switch } from "@mui/material";

/**
 * Volunteer opt-in only. Activity types are stored as preferred_event_type_ids
 * on the backend; the web account page does not edit those here (see mobile
 * VolunteerPreferencesModal for full preference editing).
 */
export default function VolunteerPreferencesSection({ volunteerPrefs, handleVolunteerChange }) {
  if (!volunteerPrefs) return null;

  return (
    <Box id="volunteer" sx={{ mb: 4, scrollMarginTop: "88px" }}>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#111", mb: 2 }}>
        Volunteer Preferences
      </Typography>

      <Box sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2, border: "1px solid #e2e8f0" }}>
        <FormControlLabel
          control={
            <Switch
              checked={!!volunteerPrefs.is_interested}
              onChange={(e) => handleVolunteerChange("is_interested", e.target.checked)}
              color="primary"
            />
          }
          label={
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Open to volunteering
            </Typography>
          }
        />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, ml: 7 }}>
          Let organizations and campaigns know you&apos;re interested in helping out.
        </Typography>
      </Box>
    </Box>
  );
}
